/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */


import React, { useRef, useEffect, useState } from 'react';
import { Image, Dropdown, Menu } from "antd";
import customStyles from "../../../../assets/styles/customStyles";
import clsx from 'clsx';
import { NavLink } from "react-router-dom";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import { capitalizeFirstLetter, exportChatFile, downloadImageCommon } from "../../../../helpers/utilities";
import ReactApexChart from "react-apexcharts";


export const Clients = (props) => {
    const { title, details } = props;
    const clients = useRef(null);
    const [numbers, setNumbers] = useState([]);
    const [data, setData] = useState([]);
    const classes = customStyles();

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(clients.current, title, type);
        }
    }

    useEffect(() => {
        Object.keys(details).length > 0 && Object?.entries(details)?.map(([i, detail]) => {
            setNumbers((prevState) => {
                return [...prevState, detail];
            });
            setData((prevState) => {
                return [...prevState, capitalizeFirstLetter(i)];
            });
        });

        return () => {
            setNumbers([]);
            setData([]);
        }

    }, []);

    const exportFile = () => {
        let newHead = [['Top Area Sales Total', 'Top City Sales Total', 'Sales Total']];
        exportChatFile(title, newHead);
    }

    const chartData = {
        chart: {
            type: "pie",
            selection: {
                enabled: false,
            }
        },
        states: {
            hover: {
                filter: {
                    type: 'none',
                    value: 0.01,
                }
            },
            active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                    type: 'none'
                }
            },
        },
        series: numbers,
        colors: ['#244165', '#ffc27a', '#ff6b6b', '#8ac8d5', '#317787', '#86c9b6'],
        dataLabels: { enabled: false },
        legend: {
            fontFamily: "Roboto",
            offsetY: -20,
            horizontalAlign: 'center',
            floating: false,
            markers: {
                radius: 0,
                offsetY: 2,
            },
            itemMargin: {
                horizontal: 0,
                vertical: 5
            },
        },
        stroke: {
            width: 2,
            colors: ['#fff']
        },
        tooltip: {
            enabled: true,
            style: {
                fontSize: '10px',
                fontFamily: 'Roboto',
                fontWeight: 500,
            },
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                return '<div class="arrow_box_clients">' +
                    '<div class="">' + w.globals.labels[seriesIndex] + '</div>' +
                    '<div class="invoices">' + series[seriesIndex] + ' Nos.</div>' +
                    '</div>';
            }
        },
        plotOptions: {
            pie: {
                expandOnClick: false,
                donut: {
                    size: "50px",
                    labels: {
                        show: false,
                    },
                    value: {
                        offsetY: -8, // -8 worked for me
                        color: '#ff00ff'
                    }
                }
            }
        },
        labels: data,
    }




    return (
        <div ref={clients} style={{ height: "100%" }}>
            <div className={clsx(classes.monthlyDiv, classes.monthlyDivClients)} style={{ height: "100%" }}>
                <div className={clsx(classes.monthlyDivTitle, classes.bold)}>
                    {`${title}`}
                    <span className={classes.hamburgerMenu}>
                        <Dropdown
                            placement="bottomLeft"
                            trigger={['click']}
                            overlay={
                                <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                    <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                    <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                                </Menu>
                            }>
                            <Image src={hamburgerMenu} preview={false} />
                        </Dropdown>
                    </span>
                </div>
                {
                    numbers && numbers.length > 0 && <ReactApexChart style={{ marginTop: 10 }} options={chartData} series={chartData.series} type="donut" height="90%" />
                }
            </div>
        </div>
    )
}